<template>
    <div class="case-container">
        <div class="case-banner">
            <div class="case-title">
                <h3>合作案例</h3>
                <h2>为全国60个大中城市提供定制化解决方案、高精度数据采集、三维精细建模、模型优化处理及应用的一站式服务</h2>
            </div>
        </div>
        <div class="case-product">
            <div class="item" v-for="item in caseArr" :index="item.name" :key="item.name">
                <div class="content">
                    <img src="@/assets/images/demo.png" width="380" height="200"/>
                </div>
                <div class="remark">
                    <span class="title">城市孪生</span>
                    <span class="desc">智慧城市</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    components: {},
    data() {
        return {
            caseArr: [1, 2, 3, 4, 5, 6]
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.case-container {
    background: #f2f2f2;
    padding-bottom:50px;
    .case-product{
        width: 1398px;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 50px;
        margin-bottom: 50px;
        flex-wrap: wrap;
        justify-content: space-between;
        .item{
            background: white;
            width: 380px;
            height: 260px;
            padding: 30px;
            margin-top: 30px;
            cursor: pointer;
            .remark{
                display: flex;
                flex-direction: column;
                margin-top: 15px;
                .title{
                    font-size: 16px;
                    font-weight: 600;
                }
                .desc{
                    margin-top: 5px;
                    font-size: 14px;
                    color: #909399;
                }
            }
        }
    }
    .case-banner{
        background: url('../../assets/images/banner.png');
        width: 100%;
        height: 200px;
        background-size: cover;
        display: flex;
        line-height: 1.1;
        .case-title{
            width: 1398px;
            margin: auto;
            color: white;
            text-align: left;
            h3{
                font-family: "Arial";
                font-size: 36px;
                margin-bottom: 20px;
                font-weight: 500;
            }
            h2{
                font-family: 微软雅黑;
                font-size: 20px;
                font-weight: 500;
            }
            h1{
                margin-top: 10px;
                font-size: 32px;
                font-family: "Arial";
                margin-bottom: 10px;
                font-weight: 500;
            }
        }
    }
}
.paddingtop30{
    padding-top: 30px;
}
.paddingtop20{
    padding-top: 20px;
}
</style>

